<template>
  <div class="home mb-5">
    <list-list :lists="displayLists">
      <template #header v-if="isAuth">
        <h3 class="my-0" >My Lists</h3>
      </template>
      <template #header v-else>
        <h4 class="header my-0">Check out some lists our users have made!</h4>
      </template>
    </list-list>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import ListList from '@/components/ListList'

export default {
  name: 'Home',
  components: {
    ListList,
  },
  computed: {
    displayLists () {
      if (this.isAuth) {
        return this.user.lists
      } else {
        return this.homelists
      }
    },
    ...mapGetters({
      isAuth: 'users/isAuth',
      user: 'users/user'
    }),
    ...mapState({
      homelists: state => state.lists.homePageLists
    })
  },
  created () {
    if (this.isAuth) {
      this.$store.dispatch('users/getUserDetails')
    } else if (this.homelists.length === 0) {
      this.$store.dispatch('lists/getHomePageLists', {order: 'random', limit: 10})
    }
  }
}
</script>

<style scoped>
h4.header {
  font-size: 1rem;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

img {
  width: 250px;
}
</style>
